<template>
  <v-row>
    <v-dialog
      persistent
      transition="scale-transition"
      :max-width="$vuetify.breakpoint.xsOnly ? '90%' : '300px'"
      v-model="component.dialog_clear"
    >
      <v-card class="mx-auto" outlined>
        <v-container class="pa-2">
          <v-row justify="center" class="ma-0">
            <v-card-title :class="$vuetify.breakpoint.xsOnly ? 'text-subtitle-1 pa-2' : ''">
              Deseja limpar o carrinho?
            </v-card-title>
          </v-row>
          
          <v-row justify="center" class="ma-0">
            <v-col cols="12" class="pa-1 text-center">
              <v-btn
                class="red darken-4 white--text"
                :small="$vuetify.breakpoint.xsOnly"
                :block="$vuetify.breakpoint.xsOnly"
                :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                @click="disableDialog"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="success"
                :small="$vuetify.breakpoint.xsOnly"
                :block="$vuetify.breakpoint.xsOnly"
                @click="component.clearCart"
              >
                Confirmar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    component: Object,
  },
  methods: {
    disableDialog() {
      this._props.component.dialog_clear = !this._props.component.dialog_clear;
    },
  },
};
</script>
